<script type="ts">
	export default {};
</script>
<template>
	<div>
		<router-view></router-view>
	</div>
</template>